// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__+ooNd","blockMsg":"Message_blockMsg__qt9Tm","avatar":"Message_avatar__h++bq","avatarBg":"Message_avatarBg__eNa4E","nameAuthor":"Message_nameAuthor__ITML-"};